var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{staticClass:"service-form"},[_c('b-form-group',{attrs:{"label":"Название службы"}},[_c('b-form-input',{model:{value:(_vm.value.name),callback:function ($$v) {_vm.$set(_vm.value, "name", $$v)},expression:"value.name"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }